export default __webpack_public_path__ + "static/media/avatar_66.ccfa7ae2.png";